import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const fetchTestSuiteResult = async (tsid, tsrid, pageNO, statusFilter, runByFilter, dateFilter) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const params = new URLSearchParams({
    action: "getTestSuiteResult",
    companyid: user.companyid,
    idtest_suite: tsid,
    TSRId: tsrid ?? "",
    pageNO: `${pageNO}`,
  });

  if (Array.isArray(statusFilter) && statusFilter.length > 0) {
    params.append("statusFilter", statusFilter.join(","));
  }

  if (Array.isArray(runByFilter) && runByFilter.length > 0) {
    params.append("runBy", runByFilter.join(","));
  }

  if (dateFilter) {
    params.append("dateFilter", dateFilter);
  }

  const response = await axios.get(`${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?${params}`);
  return response.data;
};

const useTestSuiteResultQuery = (tsid, tsrid, pageNO, options = {}) => {
  const {
    enabled,
    statusFilter = [],
    runByFilter = [],
    dateFilter = "",
    refetchInterval = false,
  } = options;
  const query = useQuery({
    queryKey: ["testSuiteResult", tsid, tsrid, pageNO, statusFilter, runByFilter, dateFilter],
    queryFn: () => fetchTestSuiteResult(tsid, tsrid, pageNO, statusFilter, runByFilter, dateFilter),
    enabled,
    retry: true,
    // cacheTime: 90000,
    refetchInterval,
    refetchIntervalInBackground: false,
    // staleTime: Infinity,
  });

  const refetchWithId = (newTsid) => {
    return query.refetch({
      queryKey: ["testSuiteResult", newTsid],
    });
  };

  return {
    ...query,
    refetch: refetchWithId,
  };
};

export default useTestSuiteResultQuery;
